@import "../../../globalStyles/commons";

:host {
  display: inline-block;
  --goat-popover-tiptab-padding: 0.5rem;
  --goat-popover-height: inherit;
  height: var(--goat-popover-height);
}

.popover {
  height: var(--goat-popover-height);

  &.tip-tab {
    padding: var(--goat-popover-tiptab-padding);
    line-height: 0;
    transition: background 0.1s ease-out 0s;

    &.open {
      background: var(--layer);
    }
  }
}

